// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../library/utils/NetworkUtils.bs.js";
import * as Logger$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as N_RnrRepoConfig from "./N_RnrRepoConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";

var dummyRnRReport = {
    "rnr_cycle": {
        "start_date": "2024-09-23",
        "end_date": "2024-11-03",
        "geo_region_id": 3,
        "vehicle_category_id": 3
    },
    "cycle_category_aggregates": [
      {
        "computers": [
          {
            "type": "ORDER_FULFILLMENT",
            "slabs": [
              {
                "order_count": 1,
                "points": 50
              },
              {
                "order_count": 2,
                "points": 100
              },
              {
                "order_count": 3,
                "points": 150
              },
              {
                "order_count": 4,
                "points": 200
              },
              {
                "order_count": 5,
                "points": 250
              },
              {
                "order_count": 6,
                "points": 300
              }
            ]
          }
        ],
        "category": "ORDER_FULFILLMENT",
        "points": 1600
      },
      {
        "computers": [
            {
                "min_rating": 5.0,
                "points": 100,
                "type": "ORDER_RATING"
            }
        ],
        "category": "CUSTOMER_EXPERIENCE",
        "points": 0
      },
      {
        "computers": [
          {
            "window_start_mins": 540,
            "window_end_mins": 1260,
            "per_hour_points": 5,
            "type": "LOGIN_HOURS"
          }
        ],
        "category": "LOGIN_ACTIVITY",
        "points": 0
      }
    ],
    "rewards": [
      {
        "qualified_order_count": 5,
        "completed_order_count": 6,
        "id": 3398,
        "type": "ORDER_RATING",
        "points": 250,
        "entitlement_date": "2023-10-26",
        "status": "UNCLAIMED",
        "category": "CUSTOMER_EXPERIENCE",
        "expiry_ts": 1698431399
      },
      {
        "login_hours": 4,
        "id": 3399,
        "type": "LOGIN_HOURS",
        "points": 20,
        "entitlement_date": "2023-10-26",
        "status": "UNCLAIMED",
        "category": "LOGIN_ACTIVITY",
        "expiry_ts": 1698431399
      },
      {
        "entitlement_date": "2023-10-26",
        "id": 3400,
        "type": "ORDER_FULFILLMENT",
        "points": 0,
        "status": "UNCLAIMED",
        "category": "ORDER_FULFILLMENT",
        "expiry_ts": 1698431399,
        "driver_cancelled_count": 1,
        "completed_count": 7,
      },
    ],
    "milestones": [
      {
        "points": 0,
        "name": "Star",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 1500,
        "name": "Bronze Hero",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 3500,
        "name": "Bronze Super Star",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 4500,
        "name": "Silver Hero",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 6000,
        "name": "Silver Super Star",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 7500,
        "name": "Platinum Hero",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 9000,
        "name": "Platinum Super Star",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 11000,
        "name": "Gold Hero",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 13500,
        "name": "Gold Super Star",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 16000,
        "name": "Porter Hero",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      },
      {
        "points": 20000,
        "name": "Supro Super Star",
        "award": {
          "type": "LUCKY_DRAW",
          "awarded_at": null
        }
      }
    ],
    "weekly_point_report" : [
      {
        "start_date": "2024-09-23",
        "end_date": "2024-09-29",
        "points": 890
      },
      {
        "start_date": "2024-09-30",
        "end_date": "2024-10-06",
        "points": 0
      },
      {
        "start_date": "2024-10-07",
        "end_date": "2024-10-13",
        "points": 20
      },
      {
        "start_date": "2024-10-14",
        "end_date": "2024-10-20",
        "points": 200
      }
	  ],
    "vehicle_category": "2_wheeler"
    };

function fetchRnrReport(uuid, auth_token, lang) {
  Logger$Catalyst.trace({
        requestUrl: "fetchRnrReportApiCalled"
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyRnRReport
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrReportResponseConverter.execute, result);
                            });
                }), "");
}

var dummyRnrClaimResponse = {
      "success": true,
      "message": "string",
      "crossed_milestone": {
        "name": "Platinum Hero",
        "points": 700,
        "award": {
          "type": "INSURANCE",
          "awarded_at": 1568374107,
          "start_date": "2019-09-13",
          "end_date": "2019-09-13",
          price: 200,
          discount: 100,
          benefit_type: "price"
        },
      },
    };

function claimRnrReward(uuid, auth_token, lang, reward_ids) {
  Logger$Catalyst.trace({
        requestUrl: "claimRnrRewardApiCalled"
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyRnrClaimResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrClaimResponseConverter.execute, result);
                            });
                }), "");
}

var dummyRnRConfigResponse = {
      "vehicle_category" : "2_wheeler",
	    "geo_region_id" : 3
    };

function fetchRnRConfig(uuid, auth_token) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyRnRConfigResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrConfigResponseConverter.execute, result);
                            });
                }), "");
}

var dummyRnRVernacularHomepageResponse = {
    "data": {
        "id": 1,
        "attributes": {
            "createdAt": "2023-10-16T07:15:53.373Z",
            "updatedAt": "2023-10-16T07:22:01.420Z",
            "publishedAt": "2023-10-16T07:22:01.413Z",
            "seasonal_campaign": {
                "id": 1,
                "milestone_title": "Complete levels to win gifts in lucky draw",
                "learn_more_header_title": "Learn about the Program",
                "milestone_message_text": "points left for next lucky draw",
                "milestone_congratulations_text": "You have qualified for today's lucky draw. Winners will be announced next week.",
                "season_details": {
                    "id": 1,
                    "season_title": "Har din Diwali 2.0",
                    "season_points_title": "TOTAL POINTS"
                }
            },
            "weekly_campaign": {
                "id": 1,
                "weekly_points_title": "THIS WEEK'S POINTS",
                "last_week_winners_and_prizes_title": "Top Weekly Points, Win Prizes, Every Week!",
                "week_title": "Weekly Competition",
                "points_collected_yesterday_table": {
                    "id": 1,
                    "title": "Yesterday's Claimed Points",
                    "login_hours_display_text": "Login Hours",
                    "order_fulfillment_display_text": "Completed Orders",
                    "order_rating_display_text": "5-Star Rating",
                    "footer_text": "Want more Points?"
                },
                "learn_more_modal": {
                    "id": 1,
                    "title": "Want more Points?",
                    "content": "\n  * Every Login hour (9am to 9pm) = 5\n  \n  * Every completed order = 50\n\n  * Every 5-STAR Rating = 50\n\n  * Claim points everyday- unclaimed points will expire in 24 hours\n\n  * 0 order cancellation allowed. You will get 0 completed order points in case of order cancellation.\n  "
                }
            },
            "points_claim_sticky_section": {
                "id": 1,
                "title": "Earn More Points to Win Attractive Prizes",
                "yesterday_points_title": "Yesterday's Points",
                "expires_in_prefix": "Expires in",
                "claim_prefix": "Claim"
            }
        }
    },
    "meta": {}
  };

function fetchRnRHomepageVernacularContent(language) {
  Logger$Catalyst.trace({
        requestUrl: "fetchRnrVernacularContentApiCalled"
      });
  Logger$Catalyst.debug({
        payload: language
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyRnRVernacularHomepageResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrVernacularCMSResponseConverter.execute, result);
                            });
                }), "");
}

var dummyRnRVernacularClaimRewardResponse = {
      
      "data": {
        "id": 1,
        "attributes": {
            "createdAt": "2023-10-25T04:22:17.674Z",
            "updatedAt": "2023-10-25T04:22:20.317Z",
            "publishedAt": "2023-10-25T04:22:20.312Z",
            "rnr_claim_reward": {
                "id": 1,
                "title_cmp": {
                    "id": 1,
                    "title_prefix": "You earned",
                    "title_suffix": "points.",
                    "title_header": "Great Work!"
                },
                "claim_reward_table": {
                    "id": 2,
                    "title": "POINTS CALCULATION",
                    "login_hours_display_text": "Login Hours",
                    "order_fulfillment_display_text": "Competed Orders",
                    "order_rating_display_text": "5-Star Rating",
                    "footer_text": "Okay"
                }
            }
        }
      },
    "meta": {}
    
  };

function fetchRnRClaimRewardVernacularContent(language) {
  Logger$Catalyst.trace({
        requestUrl: "fetchRnRClaimRewardVernacularContentCalled"
      });
  Logger$Catalyst.debug({
        payload: language
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyRnRVernacularClaimRewardResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrVernacularClaimRewardCMSResponseConverter.execute, result);
                            });
                }), "");
}

var dummyRnRVernacularLoginDetailsResponse = {
    "data": {
        "id": 1,
        "attributes": {
            "createdAt": "2023-10-25T07:16:15.246Z",
            "updatedAt": "2023-10-26T07:04:28.154Z",
            "publishedAt": "2023-10-25T07:16:17.670Z",
            "rnr_login_activity_content": {
                "id": 1,
                "login_banner_title": "Login Activity",
                "description_one": "Your Login Activity point increases when you stay online on Porter App between TIMESTAMP_REPLACE_1 to TIMESTAMP_REPLACE_2",
                "description_bold": "More you stay online, more Login Activity points you get.",
                "tips_title": "Tips",
                "description_pointers": "\n  * Try and be online more between TIMESTAMP_REPLACE_1 to TIMESTAMP_REPLACE_2\n\n  * Utilize your free time to give maximum hours to earn more\n\n  * Every hour logged in has REPLACE_POINTS points. Longer hours equals more points\n  "
            }
        }
    },
    "meta": {}
  };

function fetchRnRLoginDetailsVernacularContent(language) {
  Logger$Catalyst.trace({
        requestUrl: "fetchRnRLoginDetailsVernacularContentCalled"
      });
  Logger$Catalyst.debug({
        payload: language
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyRnRVernacularLoginDetailsResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrVernacularLoginDetailsCMSResponseConverter.execute, result);
                            });
                }), "");
}

var dummyRnRVernacularVideoDetailsResponse = {
    "data": {
        "id": 1,
        "attributes": {
            "createdAt": "2023-10-30T07:49:25.159Z",
            "updatedAt": "2023-11-03T10:20:22.946Z",
            "publishedAt": "2023-10-30T07:49:27.112Z",
            "header_title": "How to win prizes?",
            "tnc_text": "Terms & Conditions apply. Click here for details",
            "rnr_video_details": [
                {
                    "id": 1,
                    "title": "Watch the video to learn more!",
                    "video_url": "https://www.youtube.com/embed/B69tr4okyQ8?si=B69tr4okyQ8&fs=0&rel=0&autoplay=1&modestbranding=1",
                    "thumbnail_image": {
                        "data": {
                            "id": 5,
                            "attributes": {
                                "name": "thumbnail-eng (1).webp",
                                "alternativeText": null,
                                "caption": null,
                                "width": 512,
                                "height": 316,
                                "formats": {
                                    "thumbnail": {
                                        "ext": ".webp",
                                        "url": "/uploads/thumbnail_thumbnail_eng_1_d4198d89cb.webp",
                                        "hash": "thumbnail_thumbnail_eng_1_d4198d89cb",
                                        "mime": "image/webp",
                                        "name": "thumbnail_thumbnail-eng (1).webp",
                                        "path": null,
                                        "size": 6.5,
                                        "width": 245,
                                        "height": 151
                                    }
                                },
                                "hash": "thumbnail_eng_1_d4198d89cb",
                                "ext": ".webp",
                                "mime": "image/webp",
                                "size": 14.75,
                                "url": "/uploads/thumbnail_eng_1_d4198d89cb.webp",
                                "previewUrl": null,
                                "provider": "local",
                                "provider_metadata": null,
                                "createdAt": "2024-03-07T07:44:33.022Z",
                                "updatedAt": "2024-03-07T07:44:33.022Z"
                            }
                        }
                    }
                },
            ]
        }
    },
    "meta": {}
};

function fetchRnRVideoDetailsVernacularContent(language) {
  Logger$Catalyst.trace({
        requestUrl: "fetchRnRVideoDetailsVernacularContent"
      });
  Logger$Catalyst.debug({
        payload: language
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyRnRVernacularVideoDetailsResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrVernacularVideoDetailsCMSResponseConverter.execute, result);
                            });
                }), "");
}

var RnrRepo = {
  dummyRnRReport: dummyRnRReport,
  fetchRnrReport: fetchRnrReport,
  dummyRnrClaimResponse: dummyRnrClaimResponse,
  claimRnrReward: claimRnrReward,
  dummyRnRConfigResponse: dummyRnRConfigResponse,
  fetchRnRConfig: fetchRnRConfig,
  dummyRnRVernacularHomepageResponse: dummyRnRVernacularHomepageResponse,
  fetchRnRHomepageVernacularContent: fetchRnRHomepageVernacularContent,
  dummyRnRVernacularClaimRewardResponse: dummyRnRVernacularClaimRewardResponse,
  fetchRnRClaimRewardVernacularContent: fetchRnRClaimRewardVernacularContent,
  dummyRnRVernacularLoginDetailsResponse: dummyRnRVernacularLoginDetailsResponse,
  fetchRnRLoginDetailsVernacularContent: fetchRnRLoginDetailsVernacularContent,
  dummyRnRVernacularVideoDetailsResponse: dummyRnRVernacularVideoDetailsResponse,
  fetchRnRVideoDetailsVernacularContent: fetchRnRVideoDetailsVernacularContent
};

export {
  RnrRepo ,
  
}
/* NetworkUtils Not a pure module */
